module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"showProducts":"Voir les articles"},"en":{"showProducts":"See the articles"},"de":{"showProducts":"Artikel ansehen"},"es":{"showProducts":"Ver los artículos"},"it":{"showProducts":"Vedi gli articoli"},"nl":{"showProducts":"Artikels bekijken"},"pt":{"showProducts":"Ver os artigos"}}')
  delete Component.options._Ctor
}
